module.exports = __webpack_public_path__ + "kibervarnost/img/prvo-pravilo.43931cbf.jpg";